import Vue from 'vue';
import App from './App.vue';
import store from './store';
import Notifications from 'vue-notification';
import Storage from '../../../libs/vue-web-storage';
import VueNativeSock from 'vue-native-websocket';
import * as Sentry from '@sentry/vue';
import linkify from 'vue-linkify';
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import cssVars from 'css-vars-ponyfill';
import '@/assets/css/customer-styles-general.css';
import '@/assets/js/iframeResizer.contentWindow.min.js'
cssVars();

import { library } from  '@fortawesome/fontawesome-svg-core';
import {
  faSpinner,
  faEnvelope
} from  '@fortawesome/free-solid-svg-icons';
import {
  faFacebook,
  faGoogle,
  faMicrosoft
} from  '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
library.add(
  faSpinner,
  faFacebook,
  faGoogle,
  faMicrosoft,
  faEnvelope
);
Vue.component('fa-icon', FontAwesomeIcon);

// process.env.VUE_APP_ENVIRONMENT !== 'local' && Sentry.init({
//   Vue,
//   dsn: 'https://850e9d0d7469411e9a1360958711fbba@sentry.io/1788533',
//   autoSessionTracking: true,
//   environment: process.env.VUE_APP_ENVIRONMENT
// });

Vue.config.productionTip = false;

Vue.use(Storage);
Vue.use(VueNativeSock, process.env.VUE_APP_AWS_WEBSOCKET_URL, {
  store,
  format: 'json',
  reconnection: true,
  reconnectionDelay: 2000
});
Vue.use(Notifications);
Vue.directive('linkified', linkify);

new Vue({
  store,
  render: h => h(App)
}).$mount('#app');
